export default class TwitchWrapper {
  constructor( clientId ) {
    this.clientId = clientId;
    this.KrakenURL = 'https://api.twitch.tv/kraken';
    this.HelixURL = 'https://api.twitch.tv/helix';
    this.BadgesURL = 'https://badges.twitch.tv/v1/badges';
  }

  // Use Cache
  async GetANZStreams() {
    let channelIds = await this.GetFile("ids.txt")
    return {streams: (await this.GetStreams(channelIds)), channels: channelIds}
  }

  async GetANZStreamerDirectory(token) {
    var channels;

    // if (localStorage.getItem('channels') && (localStorage.getItem('channels'))){
    //   let expiration = new Date(JSON.parse(localStorage.getItem('channels')));

    //   if(new Date() < expiration) {
    //     channels = JSON.parse(localStorage.getItem(channels));
    //   }
    // }

    if(!channels) {
      let channelIds = await this.GetFile("ids.txt")
      channels = await this.GetUsersById(channelIds, token)

      localStorage.setItem('channels', JSON.stringify(channels));
      let today = new Date();
      today.setHours(today.getHours() + 1);
      localStorage.setItem('channels', JSON.stringify(today));
    }

    return channels

  }

  async GetFile(file) {
      let response = await fetch(file, {method: "GET"})

      if(!response.ok){
        let error = await response.text()
        throw new Error(error)
      }

      let data = await response.text()

      return data.trim().replace(/\r/g,'').split("\n")
  }


  async GetChannelFollowersCached(user) {
    var follows;

    if (localStorage.getItem('follows_' + user) && (localStorage.getItem('followsExpiration_' + user))){
      let expiration = new Date(JSON.parse(localStorage.getItem('followsExpiration_' + user)));

      if(new Date() < expiration) {
        follows = JSON.parse(localStorage.getItem('follows_' + user));
      }
    }

    if(!follows) {
      follows = await this.GetChannelFollowers(user);
      localStorage.setItem('follows_' + user, JSON.stringify(follows));
      let today = new Date();
      today.setHours(today.getHours() + 10);
      localStorage.setItem('followsExpiration_' + user, JSON.stringify(today));
    }
    return follows
  }

  async GetFollowedChannelsCached(user) {
    var channels;

    if (localStorage.getItem('channels_' + user) && (localStorage.getItem('channelsExpiration_' + user))){
      let expiration = new Date(JSON.parse(localStorage.getItem('channelsExpiration_' + user)));

      if(new Date() < expiration) {
        channels = JSON.parse(localStorage.getItem('channels_' + user));
      }
    }

    if(!channels) {
      channels = await this.GetFollowedChannels(user);
      localStorage.setItem('channels_' + user, JSON.stringify(channels));
      let today = new Date();
      today.setHours(today.getHours() + 10);
      localStorage.setItem('channelsExpiration_' + user, JSON.stringify(today));
    }
    return channels
  }

  async TwitchFetch(url, method = 'GET', token = null) {
      let response = await fetch(url,
      {
        headers: { 'Content-Type': 'application/json', 'Client-ID': this.clientId, 'authorization': ('Bearer ' + token)},
        method: method
      })

      if(!response.ok){
        let error = await response.text()
        throw new Error(error)
      }

      let data = await response.json()

      return data
  }

  async GetStreams(channels, live = true) {
    var limit = 100;

    // Get first page and total
    var data = [];

    // Calculate page count
    var pageCount = Math.ceil(channels.length / limit);

    if(pageCount > 0)
    {
      // Get each pages
      var dataPromises = [];
      for (var i = 0; i < pageCount; i++) {
         var x = channels.slice(limit*i, limit*(i+1));
         dataPromises.push(this.GetStreamsPage(x.join(',')));
      }

      // wait for all our results
      let results = await Promise.all(dataPromises);

      // Join results into original
      results.forEach(function (e) {
        data = data.concat(e.streams);
      });
    }

    // Filter out re-runs
    if(live){
      return data.filter(s => s.broadcast_platform !== 'rerun');
    }

    return data;
  }

  async GetUsersById(ids, token){
    var limit = 100;

    // Get first page and total
    var data = [];

    // Calculate page count
    var pageCount = Math.ceil(ids.length / limit);

    if(pageCount > 0)
    {
      // Get each pages
      var dataPromises = [];
      for (var i = 0; i < pageCount; i++) {
         var x = ids.slice(limit*i, limit*(i+1));
         dataPromises.push(this.GetUsersHelix("&id=" + x.join('&id='), token));
      }

      // wait for all our results
      let results = await Promise.all(dataPromises);
      //console.log(results)

      // Join results into original
      results.forEach(function (e) {
        data = data.concat(e.data);
      });
    }
    //console.log(data)
    return data;
  }

  async GetUsersByName(names) {
    var limit = 100;

    // Get first page and total
    var data = [];

    // Calculate page count
    var pageCount = Math.ceil(names.length / limit);

    if(pageCount > 0)
    {
      // Get each pages
      var dataPromises = [];
      for (var i = 0; i < pageCount; i++) {
         var x = names.slice(limit*i, limit*(i+1));
         dataPromises.push(this.GetUsers(x.join(',')));
      }

      // wait for all our results
      let results = await Promise.all(dataPromises);

      // Join results into original
      results.forEach(function (e) {
        data = data.concat(e.users);
      });
    }

    return data;
  }

  async GetChannelById(channel, token){
    return await this.TwitchFetch(`${this.KrakenURL}/channels/${channel}?api_version=5`, 'GET', token);
  }

  async GetChannelBadges(channel) {
    return await this.TwitchFetch(`${this.BadgesURL}/channels/${channel}/display`);
  }

  async GetStreamsPage(channels, type = "live") { 
    return await this.TwitchFetch(`${this.KrakenURL}/streams/?limit=100&stream_type=${type}&api_version=5&channel=${channels}`) 
  }

  async GetUser(token) {
    return await this.TwitchFetch('${this.KrakenURL}/user?api_version=5', 'GET', token);
  }

  async GetChannelId(streamers) {
    return await this.TwitchFetch(`${this.KrakenURL}/users/?login=${streamers}&api_version=5`);
  }

  async GetChatBadges(channel) {
    return await this.TwitchFetch(`${this.KrakenURL}/chat/${channel}/badges?api_version=5`);
  }

  async GetTeam(name) {
    return await this.TwitchFetch(`${this.KrakenURL}/teams/${name}/?api_version=5`);
  }

  async GetFollowedChannelsPage(user, limit, offset) {
    return await this.TwitchFetch(`${this.KrakenURL}/users/${user}/follows/channels?api_version=5&limit=${limit}&offset=${offset}`);
  }

  async GetChannelFollowersPage(user, limit, offset, cursor) {
    if(cursor){
      return await this.TwitchFetch(`${this.KrakenURL}/channels/${user}/follows?api_version=5&limit=${limit}&offset=${offset}&cursor=${cursor}`);
    }
    else {
     return await this.TwitchFetch(`${this.KrakenURL}/channels/${user}/follows?api_version=5&limit=${limit}&offset=${offset}`); 
    }
    
  }

  async FollowChannel(userId, channelId, token) {
      return await this.TwitchFetch(`${this.KrakenURL}/users/${userId}/follows/channels/${channelId}?api_version=5`, 'PUT', token);
  }

  async UnfollowChannel(userId, channelId, token) {
    return await this.TwitchFetch(`${this.KrakenURL}/users/${userId}/follows/channels/${channelId}?api_version=5`, 'DELETE', token);
  }

  async GetUsers(users) {
    return await this.TwitchFetch(`${this.KrakenURL}/users/?api_version=5&login=${users}`);
  }

  async GetUsersHelix(users, token) {
    return await this.TwitchFetch(`${this.HelixURL}/users/?${users}`, 'GET', token);
  }

  async GetUserId(user, token) { 
    var result = await this.TwitchFetch(`${this.HelixURL}/users?login=${user}`, 'GET', token); 
 
    if(result.data.length < 1) { 
      throw 'No user found' 
    } 
     
    return result.data[0].id; 
  } 

  async GetChannelFollowers(user) {
    var limit = 100;

    // Get first page and total
    var data = await this.GetChannelFollowersPage(user, limit, 0);

    // Calculate page count
    var pageCount = Math.ceil(data._total / limit);

    if(pageCount > 1)
    {
      // Get each pages
      var results = null;
      //console.log(data)
      //console.log(data._cursor)
      var cursor = data._cursor;

      for (var i = 1; i < pageCount+2; i++) {
        results = await this.GetChannelFollowersPage(user, limit, 100, cursor)
        cursor = results._cursor
        data.follows = data.follows.concat(results.follows);
      }
    }
    var follows = data.follows;

    return follows
  }

  async GetFollowedChannels(user) {
    var limit = 100;

    // Get first page and total
    var data = await this.GetFollowedChannelsPage(user, limit, 0);

    // Calculate page count
    var pageCount = Math.ceil(data._total / limit);

    if(pageCount > 1)
    {
      // Get each pages
      var dataPromises = [];
      for (var i = 1; i < pageCount+1; i++) {
        dataPromises.push(this.GetFollowedChannelsPage(user, limit, i * limit))
      }

      // wait for all our results
      let results = await Promise.all(dataPromises);

      // Join results into original
      results.forEach(function (e) {
        data.follows = data.follows.concat(e.follows);
      });
    }

    return data.follows.map(c => {
      c.channel.followed_at = c.created_at
      return c.channel
    });
  }

  async GetClipsBatched(broadcaster_id, dates, token){
    let clips = []

    for (var i = 0; i < dates.length; i++) {
      let results = await this.GetClips(broadcaster_id, encodeURIComponent(dates[i].from), encodeURIComponent(dates[i].to), token);
      clips = clips.concat(results);
    }

    var game_ids = clips.map(d => d.game_id);
    game_ids = game_ids.filter(function(v,i) { return game_ids.indexOf(v) == i; }).filter(function(el){return el != ""});
    var games = await this.GetGamesBatched(game_ids, token);

    clips = clips.map(function(e) {
      e.game = games.data.find((g) => g.id === e.game_id);
      return e;
    })

    return clips;
  }

  async GetClips(broadcaster_id, ended_at, started_at, token) {
    var limit = 50;

    // Get first page and total
    var data = [];

    var results = [];
    results.push(await this.GetClipsPage(broadcaster_id, limit, ended_at, started_at, token));

    var i = 0;

    while (results[results.length - 1].data.length > 0) {
      i += limit;
      var c = newCursor(i);
      results.push(await this.GetClipsPage(broadcaster_id, limit, ended_at, started_at, token, c));
    }

    // Join results into original
    results.forEach(function(e) {
      data = data.concat(e.data);
    });

    // Skip games calls if no results
    if(data.length <= 0){return data;}

    return this.uniqBy(data, 'id');
  }

  async GetClipsPage(broadcaster_id, limit, started_at, ended_at, token, cursor) {
    var url = `${this.HelixURL}/clips?broadcaster_id=${broadcaster_id}&first=${limit}&started_at=${started_at}&ended_at=${ended_at}`
   
    if (cursor !== undefined) { 
      url = `${this.HelixURL}/clips?broadcaster_id=${broadcaster_id}&after=${cursor}&first=${limit}&started_at=${started_at}&ended_at=${ended_at}`
    }

    return await this.TwitchFetch(url, 'GET', token);
  }

  async GetVideos(broadcaster_id, type, token) {
    var limit = 100;

    // Get first page and total
    var data = [];

    var results = [];
    results.push(await this.GetVideoPage(broadcaster_id, limit, type, token));

    var i = 0;
    while (results[results.length - 1].data.length > 0) {
      i += limit;
      var c = results[results.length - 1].pagination.cursor;
      results.push(await this.GetVideoPage(broadcaster_id, i, type, token, c));
    }

    // Join results into original
    results.forEach(function(e) {
      data = data.concat(e.data);
    });

    // Skip games calls if no results
    if(data.length <= 0){return data;}

    return this.uniqBy(data, 'id');
  }

  async GetVideoPage(broadcaster_id, limit, type, token, cursor) {
    var url = `${this.HelixURL}/videos?user_id=${broadcaster_id}&first=${limit}&type=${type}`
    if (cursor !== undefined) { 
      url += '&after=' + cursor;
    }

    return await this.TwitchFetch(url, 'GET', token);
  }

  async GetGamesBatched(game_ids, token){
    let games = {data: []}
    let game_batch_size = 100

    for (var i = 0; i < game_ids.length; i+=game_batch_size) {
      let results = await this.GetGames(game_ids.slice(i,i+game_batch_size), token);
      games.data = games.data.concat(results.data);
    }

    return games;
  }

  async GetGames(game_ids, token) {
    var games = game_ids;
    if(this.isArray(games)) {games = games.join('&id=') }

    return await this.TwitchFetch(`${this.HelixURL}/games?id=${games}`, 'GET', token);
  }

  isArray (value) {
    return value && typeof value === 'object' && value.constructor === Array;
  }

  uniqBy(arr, predicate) {
    const cb = typeof predicate === 'function' ? predicate : (o) => o[predicate];
    
    return [...arr.reduce((map, item) => {
      const key = cb(item);
      
      map.has(key) || map.set(key, item);
      
      return map;
    }, new Map()).values()];
  }
}

function newCursor(i) {
    return btoa(JSON.stringify({'b': null, 'a' : {'Cursor': btoa(i)}})).trimRight('=');
}

String.prototype.trimRight = function(charlist) {
  if (charlist === undefined)
    charlist = "\s";

  return this.replace(new RegExp("[" + charlist + "]+$"), "");
};